import scssConstants from './variables.module.scss';

export const styleConstants = {
    headerMargin: parseInt(scssConstants.headerMargin),
    spaceAround: parseInt(scssConstants.spaceAround),
    toolbarHeight: parseInt(scssConstants.toolbarHeight),
    legendHeight: parseInt(scssConstants.legendHeight),
    minLegendWidth: parseInt(scssConstants.minLegendWidth),
    minLegendEditingWidth: parseInt(scssConstants.minLegendEditingWidth),
};
